export const CLEANING_VIEWS = ["received", "arrived", "cleaning", "completed"] as const;
export type CleaningView = typeof CLEANING_VIEWS[number];
export type CleaningViewCounts = Record<CleaningView, number>;

export const CLEANING_VIEW_LABELS: Record<CleaningView, string> = {
  received: "受付リスト",
  arrived: "倉庫到着注文",
  cleaning: "クリーニング中",
  completed: "完了履歴",
};

export function isCleaningView(value: unknown): value is CleaningView {
  return CLEANING_VIEWS.some((view) => view === value);
}

export function emptyCleaningViewCounts(): CleaningViewCounts {
  return { received: 0, arrived: 0, cleaning: 0, completed: 0 };
}
